import client from '@/shared/apis/client'
import { Pharmacist } from '@/features/auth/types/pharmacy'
import { PharmacistFormData } from '@/features/internal/pharmacist/types/pharmacist'

export const createPharmacist = async (
  data: PharmacistFormData
): Promise<Pharmacist> => {
  const response = await client.post<Pharmacist>('/api/pharmacists/', data)
  return response.data
}

export const updatePharmacist = async (
  id: string,
  data: Partial<PharmacistFormData>
): Promise<Pharmacist> => {
  const response = await client.patch<Pharmacist>(
    `/api/pharmacists/${id}/`,
    data
  )
  return response.data
}

export const deletePharmacist = async (id: string): Promise<void> => {
  await client.delete(`/api/pharmacists/${id}/`)
}
